// Action type constants

const APPROVE_APPLICATION_DOCUMENT = "APPROVE_APPLICATION_DOCUMENT";
const REJECT_APPLICATION_DOCUMENT = "REJECT_APPLICATION_DOCUMENT";
const UNAPPROVE_APPLICATION_DOCUMENT = "UNAPPROVE_APPLICATION_DOCUMENT";
const UNREJECT_APPLICATION_DOCUMENT = "UNREJECT_APPLICATION_DOCUMENT";
const FETCH_APPLICATION_TEMPLATES = "FETCH_APPLICATION_TEMPLATES";
const FETCH_APPLICATION_BY_ID = "FETCH_APPLICATION_BY_ID";
const FETCH_APPLICATIONS = "FETCH_APPLICATIONS";
const DELETE_APPLICATION = "DELETE_APPLICATION";
const FILTER_APPLICATIONS = "FILTER_APPLICATIONS";
const CLEAR_FILTER = "CLEAR_FILTER";

export default {
	APPROVE_APPLICATION_DOCUMENT,
	REJECT_APPLICATION_DOCUMENT,
	UNAPPROVE_APPLICATION_DOCUMENT,
	UNREJECT_APPLICATION_DOCUMENT,
	FETCH_APPLICATION_TEMPLATES,
	FETCH_APPLICATION_BY_ID,
	FETCH_APPLICATIONS,
	DELETE_APPLICATION,
	FILTER_APPLICATIONS,
	CLEAR_FILTER,
};
